module.exports = __webpack_public_path__ + "static/media/temperature-frigid.1de87617.svg";